// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1sh19","sendOtp":"AuthorizeToLogin_sendOtp__3hRti"};